import UserProfile from "./userManagement";
import ConsoleLogger from "../Utils/ConsoleLogger"; 
import CookiesHandler from "../Utils/CookiesHandler";
let config = require('../Config/appConfig.json');
let hasTokenUrl = config.HAS_TOKEN;
var status = "";
const context  = "CheckAuth";
var checkAuth = (function() {
    

    var CheckAuth = function(){

      return "true";
     
        var self = this;
        var user_api_token = UserProfile.getSessionId();
        var access_token = UserProfile.getInstance();
        var refresh_token = UserProfile.getRefreshToken();

        ConsoleLogger.log("CheckAuth ","ID TOKEN =>  "+user_api_token);
        ConsoleLogger.log("CheckAuth ","Access TOKEN =>  "+access_token);
        ConsoleLogger.log("CheckAuth ","Refresh TOKEN =>  "+refresh_token);
        if((user_api_token === "")||(user_api_token == null)||(access_token === "")||(access_token == null)||(refresh_token === "")||(refresh_token == null)||
        (user_api_token === undefined) || (access_token === undefined) || (refresh_token === undefined)){
            ConsoleLogger.log(context,"Authorization is FALSE");
            UserProfile.logout();
            status = "false";
          //return false;
        }else{
          status = "true";
          
        }

        return status;

    } 

    var CreateAuth = function(name,phone_number,email_id,user_name,id_token){

      ConsoleLogger.log(context,"In Create Auth");

        UserProfile.setName(name);
        UserProfile.setPhoneNumber(phone_number);
        UserProfile.setEmailId(email_id);
        UserProfile.setUserName(user_name);
        UserProfile.id_token(id_token);

       ConsoleLogger.log(context,"Auth Created");

    
    }
  
    return {
      CheckAuth: CheckAuth,
      CreateAuth: CreateAuth
    }
  
  })();
  
  export default checkAuth;


// WEBPACK FOOTER //
// ./src/Utils/checkAuth.js